<template>
  <div ref="chart" style="margin:0 auto;"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "eChartthree",
  data() {
    return {};
  },
  mounted() {},
  methods: {
    initChart(ordernum) {
      var scale = 1;
      // var ordernum = [
      //   {
      //     value: 2154,
      //     name: "曲阜师范大学"
      //   },
      //   {
      //     value: 3854,
      //     name: "潍坊学院"
      //   },
      //   {
      //     value: 3515,
      //     name: "青岛职业技术学院"
      //   }
      // ];
      var rich = {
        yellow: {
          color: "#ffc72b",
          fontSize: 30 * scale,
          padding: [5, 4],
          align: "center"
        },
        total: {
          color: "#ffc72b",
          fontSize: 40 * scale,
          align: "center"
        },
        blue: {
          color: "#49dff0",
          fontSize: 16 * scale,
          align: "center"
        },
        hr: {
          borderColor: "#0b5263",
          width: "100%",
          borderWidth: 1,
          height: 0
        }
      };
      const myChart = echarts.init(this.$refs.chart);
      const option = {
        // backgroundColor: "#031f2d",
        title: {
          text: "总订单量",
          left: "center",
          top: "53%",
          padding: [24, 0],
          textStyle: {
            color: "pink",
            fontSize: 18 * scale,
            align: "center"
          }
        },
        legend: {
          selectedMode: false,
          formatter: function(name) {
            var total = 0; //各科正确率总和
            var averagePercent; //综合正确率
            ordernum.forEach(function(value, index, array) {
              total += value.value;
            });
            return "{total|" + total + "}";
          },
          data: [ordernum[0].name],
          // data: ['高等教育学'],
          // itemGap: 50,
          left: "center",
          top: "center",
          icon: "none",
          align: "center",
          textStyle: {
            color: "#fff",
            fontSize: 16 * scale,
            rich: rich
          }
        },
        series: [
          {
            name: "总订单量",
            type: "pie",
            radius: ["42%", "50%"],
            hoverAnimation: false,
            color: [
              "#c487ee",
              "#deb140",
              "#49dff0",
              "#034079",
              "#6f81da",
              "#00ffb4"
            ],
            label: {
              normal: {
                formatter: function(params, ticket, callback) {
                  var total = 0; //考生总数量
                  var percent = 0; //考生占比
                  ordernum.forEach(function(value, index, array) {
                    total += value.value;
                  });
                  percent = (params.value / total * 100).toFixed(1);
                  return (
                    "{white|" +
                    params.name +
                    "}\n{hr|}\n{yellow|" +
                    params.value +
                    "}\n{blue|" +
                    percent +
                    "%}"
                  );
                },
                rich: rich
              }
            },
            labelLine: {
              normal: {
                length: 55 * scale,
                length2: 0,
                lineStyle: {
                  color: "#0b5263"
                }
              }
            },
            data: ordernum
          }
        ]
      };

      myChart.setOption(option);
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/statistics/user/part/echartthree.vue